<template>
  <div style="min-height: 92vh">
    <div>
      <h3>Costos de Transportacion por Hotel</h3>
      <uv-data-table
        :config="config"
        :data="data_hotel"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Modificar Precios">
      <editform
        :key="formKey"
        @toggle="toggleModal"
        :editData="editedHotel"
        @successData="successData"
      ></editform>
    </modal>
  </div>
</template>

<style></style>

<script>
import modal from "../../MainComponents/modal.vue";
import editform from "../CostosTransportacion/preciosTransForm.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";

export default {
  name: "CostoTransportacion",
  components: {
    modal,
    editform,
    uvDataTable,
  },
  props: [],
  data() {
    return {
      self: this,
      showModal: false,
      formKey: 0,
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      config: {
        selectableRow: true,
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Editar Transportación",
            icon: "lni lni-pencil-alt",
            buttonId: "editHotelTrans",
            require: true,
          },
        ],
        fields: [
          {
            title: "Nombre",
            dataName: "nombre",
            text: "Nombre",
            value: "nombre",
          },
          {
            title: "Transportacion",
            dataName: "transportacion",
            text: "Transportacion",
            value: "transportacion",
            format: (row) => {
              if (row["transportacion"] == false) {
                return '<span style="background-color: red; color: white; padding: 4px 8px; border-radius: 4px;">Inactivo</span>';
              } else if (row["transportacion"] == true) {
                return '<span style="background-color: green; color: white; padding: 4px 8px; border-radius: 4px;">Activo</span>';
              }
            },
          },
          {
            title: "Round Trip",
            dataName: "PrecioRT",
            text: "Round Trip",
            value: "PrecioRT",
            format: (row) => {
              return (
                "$" +
                (row["PrecioRT"] ? row["PrecioRT"] : "Por Definir") +
                "USD"
              );
            },
          },
          {
            title: "One Way",
            dataName: "PrecioOWHG",
            text: "One Way",
            value: "PrecioOWHG",
            format: (row) => {
              return (
                "Hotel -> Campo : $" +
                (row["PrecioOWHG"] ? row["PrecioOWHG"] : "Por Definir") +
                "USD</br> Campo -> Hotel : $" +
                (row["PrecioOWGH"] ? row["PrecioOWGH"] : "Por Definir") +
                "USD"
              );
            },
          },
        ],
      },
    };
  },
  methods: {
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "editHotelTrans") {
        this.formKey++;
        this.editedHotel = this.getHotelinfoById(idSelected[0]);
        this.toggleModal(true);
      }
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      const snapshot =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "RVA/Mayoristas/Coleccion"
        );
      this.hoteles = [];
      let arrayHoteles = Object.entries(snapshot.val());
      arrayHoteles.forEach((element) => {
        this.hoteles.push({ id: element[0], ...element[1] });
      });
    },
    deletHotel(idHotel) {
      this.$swal({
        title: "¿Deseas eliminar este Hotel?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          let data = { hId: idHotel };
          return await this.$store.getters.getFirebaseApp.fba
            .call("Golf-Hoteles-eliminarHotel", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Hotel elimando",
              "El hotel se elimino correctamente",
              "success"
            );
            this.$emit("changeIndex");
          } else {
            this.$swal("Error saving data", "Your data didnt save", "error");
          }
        }
      });
    },
    successData(data) {
      this.$pgsHelper.log(data);
      let datos = {
        Id: data.Id,
        epHotelId: data.epHotelId,
        PrecioRT: parseFloat(data.PrecioRT),
        PrecioOWGH: parseFloat(data.PrecioOWGH),
        PrecioOWHG: parseFloat(data.PrecioOWHG),
        ActiTrans: data.transportacionActivada,
        DuracionViaje: data.duracion,
      };
      this.$pgsHelper.log(datos);
      this.saveHotel(datos);
    },
    saveHotel(data) {
      this.$swal({
        title: "¿Deseas modificar los precios de transportación?",
        text: "Los costos seran modificados con los proporcionados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("RVA-Mayoristas-editarTransportacion", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal(
              "Cambio guardados",
              "El cambio de precio se almaceno correctamente",
              "success"
            );

            this.showModal = false;
            this.formKey++;
          } else {
            this.$swal("Error saving data", result.value.data.error, "error");
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async getUsers() {
      let user = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "Golf/Hoteles/Usuarios/"
      );
      if (user.exists()) {
        let result = Object.entries(user.val());
        result.forEach((element) => {
          element[1] = Object.entries(element[1]);
        });
        //result[1]  =   Object.entries(result[1]);
        this.usuarios = result;
      }
    },
    getHotelinfo(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { Codigo: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    getHotelinfoById(code) {
      let itemIndex = this.$_.findIndex(this.hoteles, { id: code });
      if (itemIndex >= 0) {
        return this.hoteles[itemIndex];
      }

      return false;
    },
    getUserName(fullUser) {
      let dash = fullUser.split("_");
      let at = dash[1].split("@");
      return at[0];
    },
  },
  computed: {
    data_hotel() {
      let data = [];
      this.hoteles.forEach((htl) => {
        let hotel = {
          id: htl.id,
          nombre: htl.Nombre,
          transportacionData: htl.Transportacion,
          transportacion: htl.ActiTrans ? htl.ActiTrans : false,
          PrecioRT: htl.Transportacion ? htl.Transportacion.PrecioRT : 0,
          PrecioOWGH: htl.Transportacion ? htl.Transportacion.PrecioOWGH : 0,
          PrecioOWHG: htl.Transportacion ? htl.Transportacion.PrecioOWHG : 0,
        };

        data.push(hotel);
      });

      return data;
    },
  },
  watch: {},
  mounted() {},
  created() {
    this.getHoteles();
    this.getUsers();
  },
};
</script>
